module.exports = "<div class=\"_automations-view\">\n\n  <cm-table-installers></cm-table-installers>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/installersView/installersView.vue
// module id = 392
// module chunks = 0